<template>
    <nav class="mobile-tabbar">
      <button
        v-for="item in items"
        :key="item.route"
        class="tabbar-item"
        :class="{ active: isActive(item) }"
        @click="goTo(item)"
      >
        <img
          :src="item.icon"
          class="tabbar-icon"
          :class="{ active: isActive(item) }"
          :alt="item.label"
        />
  
        <span class="tabbar-label">
          {{ item.label }}
        </span>
      </button>
    </nav>
  </template>
  
  <script setup>
  import { useRoute, useRouter } from "vue-router";
  
  const route = useRoute();
  const router = useRouter();
  
  const items = [
    {
      label: "Лента",
      route: "/feed",
      icon: "/tab-feed.png",
    },
    {
      label: "Коннект",
      route: "/connect",
      icon: "/tab-connect.png",
    },
    {
      label: "Диалоги",
      route: "/m-dialogs",
      desktopRoute: "/dialogs",
      icon: "/tab-dialogs.png",
    },
    {
    label: "Профиль",
    route: "/m-profile",
    icon: "/tab-profile.png",
    },
  ];
  
  const isActive = (item) => {
    return route.path === item.route || route.path === item.desktopRoute;
  };
  
  const goTo = (item) => {
    if (route.path === item.route) return;
    router.push(item.route);
  };
  </script>
  
  <style scoped>
  .mobile-tabbar {
  width: 100%;
  height: 74px;
  padding: 8px 10px calc(8px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  background: var(--footer-bg);
  border-top: 1px solid var(--separator_home);
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-shrink: 0;
}

.tabbar-item {
  all: unset;
  flex: 1;
  height: 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-family: "Eastman-Regular", sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  cursor: pointer;
}

.tabbar-item.active {
  color: #2173E5;
  font-family: "Eastman-Medium", sans-serif;
}

.tabbar-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  opacity: 0.7;

  filter: grayscale(100%);
}

.tabbar-icon.active {
  opacity: 1;

  filter:
    brightness(0)
    saturate(100%)
    invert(37%)
    sepia(94%)
    saturate(1977%)
    hue-rotate(204deg)
    brightness(96%)
    contrast(93%);
}

.tabbar-label {
  line-height: 1;
  white-space: nowrap;
}

/* DARK */

html[data-theme="dark"] .mobile-tabbar {
  background: #161616;
  border-top: 1px solid #2f2f2f;
}

html[data-theme="dark"] .tabbar-item {
  color: #9f9f9f;
}

html[data-theme="dark"] .tabbar-item.active {
  color: #2173E5;
}

html[data-theme="dark"] .tabbar-icon {
  opacity: 0.8;
  filter: brightness(0) invert(1);
}

html[data-theme="dark"] .tabbar-icon.active {
  opacity: 1;

  filter:
    brightness(0)
    saturate(100%)
    invert(37%)
    sepia(94%)
    saturate(1977%)
    hue-rotate(204deg)
    brightness(96%)
    contrast(93%);
}

@media (min-width: 769px) {
  .mobile-tabbar {
    display: none;
  }
}

  </style>